import { APP_ROUTES_ADD_FORMS, APP_ROUTES_RECP_DOC_TEMP_NEW } from '@data'
import { yupResolver } from '@hookform/resolvers/yup'
import { useAppSelector } from '@store/hooks'
import { FormButton, FormInputField, Modal, SelectInputField } from '@ui'
import { Box, Form } from 'grommet'
import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { InferType, object, string } from 'yup'

type Props = {
  onClose: () => void
  options?: string[]
}

const formSchema = object({
  category: string().required('Category is required'),
  title: string().required('name is required')
})

export type FormPayload = InferType<typeof formSchema>

export const NewForm = ({ onClose, options }: Props) => {
  const categoryStore = useAppSelector(state => state.config.document_categories)
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const mode = searchParams.get('mode')
  const id = searchParams.get('intake_id')
  const category = searchParams.get('category')
  const title = searchParams.get('title')
  const navigate = useNavigate()
  const methods = useForm({
    defaultValues: { category: category || '', title: title || '' },
    resolver: yupResolver(formSchema)
  })
  const { handleSubmit, reset } = methods
  const handleClose = () => {
    onClose()
    reset()
  }
  console.log(pathname)

  useEffect(() => {
    if (id) {
      reset({ category: category || '', title: title || '' })
    }
  }, [id, reset, category, title])

  const onSubmit = (payload: FormPayload) => {
    console.log(payload)
    if (!mode) {
      if (pathname === '/forms') navigate(`${APP_ROUTES_ADD_FORMS}?category=${payload.category}&title=${payload.title}`)
      if (pathname.includes('document-template'))
        navigate(`${APP_ROUTES_RECP_DOC_TEMP_NEW}?intake_id=${id}&category=${payload.category}&title=${payload.title}`)
    }
    onClose()
  }
  return (
    <FormProvider {...methods}>
      <Modal
        onClose={() => {
          onClose()
          reset()
        }}
        title={mode ? 'Edit Entry' : 'Add Entry'}
      >
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box flex={false} gap={'20px'} overflow="auto" pad={{ horizontal: '32px', vertical: '16px' }}>
            {id ? (
              <Box pad="0">
                <SelectInputField
                  dropProps={{
                    align: { left: 'left', right: 'right', top: 'bottom' }
                  }}
                  label="Title"
                  name="title"
                  options={options || []}
                  placeholder=""
                />
              </Box>
            ) : (
              <Box pad="0">
                <FormInputField label="Title" name="title" placeholder="" />
              </Box>
            )}

            <Box pad="0">
              <SelectInputField
                dropProps={{
                  align: { bottom: 'top', left: 'left', right: 'right' },
                  height: '200px'
                }}
                label="Category"
                labelKey={'name'}
                name="category"
                options={categoryStore?.map(item => ({
                  name: item.replace(/_/g, ' '),
                  value: item.toLowerCase().replace(/ /g, '_')
                }))}
                placeholder=""
                valueKey={{ key: 'value', reduce: true }}
              />
            </Box>
          </Box>
          <FormButton onClose={handleClose} submit="Proceed" />
        </Form>
      </Modal>
    </FormProvider>
  )
}
